<template lang="pug">
  v-container
    v-btn(v-if="showLetters" small color="primary" @click="openTutorial" absolute right)
        v-icon mdi-play
        | Ver tutorial
    v-btn(v-else small color="primary" @click="openTutorial" absolute right)
        v-icon mdi-play
</template>

<script>
  export default {
    props: {
      component: String,
      showLetters: {
        default: true,
      },
    },
    methods: {
      openTutorial () {
        const vm = this
        vm.$store.dispatch('dialogs/setTutorialVideo', vm.component).then(() => {
          vm.$store.dispatch('dialogs/openDialog', 'tutorialDialog')
        })
      },
    },
  }
</script>
